import './overview/module.js';
import alertTypeService from './alertTypeService.js';
import { react2angular } from 'react2angular';
import { SeverityIcon } from '../../../common/ui/icons/SeverityIcon';

angular
    .module('signalview.alerts', [
        'signalview.alertsOverview',
        'sfx.ui',
        'sfx.data',
        'signalboost',
        'signalview.sfGlobalNav',
    ])
    .service('alertTypeService', () => alertTypeService)
    .component('severityIcon', react2angular(SeverityIcon, ['severity', 'size']));
